import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 api-doc" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted py-4"
}
const _hoisted_4 = {
  key: 1,
  class: "doc-error",
  role: "alert"
}
const _hoisted_5 = { class: "doc-intro" }
const _hoisted_6 = { class: "doc-intro-top" }
const _hoisted_7 = { class: "doc-h1" }
const _hoisted_8 = { class: "doc-downloads" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_11 = {
  key: 1,
  class: "ph ph-file-pdf me-1",
  "aria-hidden": "true"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_14 = {
  key: 1,
  class: "ph ph-paper-plane-tilt me-1",
  "aria-hidden": "true"
}
const _hoisted_15 = {
  class: "doc-toc",
  "aria-label": "Sommaire"
}
const _hoisted_16 = ["href", "onClick"]
const _hoisted_17 = {
  id: "doc-endpoint",
  class: "doc-section"
}
const _hoisted_18 = { class: "doc-kv" }
const _hoisted_19 = { class: "badge text-outline-primary rounded-pill" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  id: "doc-auth",
  class: "doc-section"
}
const _hoisted_22 = { class: "doc-list" }
const _hoisted_23 = {
  id: "doc-params",
  class: "doc-section"
}
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table doc-table" }
const _hoisted_26 = {
  key: 0,
  class: "badge text-outline-danger rounded-pill"
}
const _hoisted_27 = {
  key: 1,
  class: "badge text-outline-secondary rounded-pill"
}
const _hoisted_28 = {
  key: 2,
  class: "badge text-outline-warning rounded-pill"
}
const _hoisted_29 = {
  id: "doc-statuses",
  class: "doc-section"
}
const _hoisted_30 = { class: "doc-list" }
const _hoisted_31 = { class: "table-responsive" }
const _hoisted_32 = { class: "table doc-table" }
const _hoisted_33 = {
  id: "doc-format",
  class: "doc-section"
}
const _hoisted_34 = { class: "doc-note" }
const _hoisted_35 = {
  id: "doc-errors",
  class: "doc-section"
}
const _hoisted_36 = { class: "table-responsive" }
const _hoisted_37 = { class: "table doc-table" }
const _hoisted_38 = { class: "doc-note" }
const _hoisted_39 = {
  id: "doc-examples",
  class: "doc-section"
}
const _hoisted_40 = { class: "doc-h3" }
const _hoisted_41 = {
  id: "doc-trace",
  class: "doc-section"
}
const _hoisted_42 = { class: "doc-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeBlock = _resolveComponent("CodeBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
            _createElementVNode("span", {
              class: "spinner-border spinner-border-sm me-2",
              role: "status"
            }, null, -1),
            _createTextVNode("Chargement de la documentation… ", -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("i", {
                class: "ph ph-warning-circle",
                "aria-hidden": "true"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
            ]))
          : (_ctx.spec)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("header", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.spec.title), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-primary",
                        disabled: !!_ctx.downloading,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.download('pdf')))
                      }, [
                        (_ctx.downloading === 'pdf')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                          : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                        _cache[4] || (_cache[4] = _createTextVNode(" Télécharger PDF ", -1))
                      ], 8, _hoisted_9),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-primary",
                        disabled: !!_ctx.downloading,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download('postman')))
                      }, [
                        (_ctx.downloading === 'postman')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                          : (_openBlock(), _createElementBlock("i", _hoisted_14)),
                        _cache[5] || (_cache[5] = _createTextVNode(" Collection Postman ", -1))
                      ], 8, _hoisted_12)
                    ])
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_ctx.spec.intro), 1),
                  _renderSlot(_ctx.$slots, "intro", {}, undefined, true)
                ]),
                _createElementVNode("nav", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (s) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: s.id,
                      href: `#${s.id}`,
                      onClick: _withModifiers(($event: any) => (_ctx.scrollTo(s.id)), ["prevent"])
                    }, _toDisplayString(s.label), 9, _hoisted_16))
                  }), 128))
                ]),
                _createElementVNode("section", _hoisted_17, [
                  _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "doc-h2" }, "1. Endpoint", -1)),
                  _createElementVNode("dl", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("dt", null, "URL", -1)),
                      _createElementVNode("dd", null, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.spec.endpoint), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("dt", null, "Méthode", -1)),
                      _createElementVNode("dd", null, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.spec.method), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Format", -1)),
                      _createElementVNode("dd", null, _toDisplayString(_ctx.spec.format), 1)
                    ]),
                    (_ctx.spec.statuses_endpoint)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Statuts", -1)),
                          _createElementVNode("dd", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "badge text-outline-primary rounded-pill me-2" }, "GET", -1)),
                            _createElementVNode("code", null, _toDisplayString(_ctx.spec.statuses_endpoint), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("dt", null, "Limite", -1)),
                      _createElementVNode("dd", null, _toDisplayString(_ctx.spec.rate_limit) + " requêtes par minute et par adresse IP (au-delà : HTTP 429)", 1)
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_21, [
                  _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "doc-h2" }, "2. Authentification", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.spec.auth.intro), 1),
                  _createVNode(_component_CodeBlock, {
                    code: _ctx.spec.auth.header
                  }, null, 8, ["code"]),
                  _createElementVNode("ul", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spec.auth.notes, (n, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(n), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("section", _hoisted_23, [
                  _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "doc-h2" }, "3. Paramètres", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                      _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { scope: "col" }, "Champ"),
                          _createElementVNode("th", { scope: "col" }, "Type"),
                          _createElementVNode("th", { scope: "col" }, "Obligatoire"),
                          _createElementVNode("th", { scope: "col" }, "Description")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spec.params, (p) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: p.name
                          }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("code", null, _toDisplayString(p.name), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(p.type), 1),
                            _createElementVNode("td", null, [
                              (p.required === 'yes')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Oui"))
                                : (p.required === 'no')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Non"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_28, "Selon statut"))
                            ]),
                            _createElementVNode("td", null, _toDisplayString(p.description), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_29, [
                  _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "doc-h2" }, "4. Statuts acceptés", -1)),
                  _createElementVNode("ul", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spec.status_rules, (r, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(r), 1))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("table", _hoisted_32, [
                      _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { scope: "col" }, [
                            _createTextVNode("Code "),
                            _createElementVNode("code", null, "statut")
                          ]),
                          _createElementVNode("th", { scope: "col" }, "Libellé"),
                          _createElementVNode("th", { scope: "col" }, "comment"),
                          _createElementVNode("th", { scope: "col" }, "reported_date")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spec.statuses, (st) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: st.code
                          }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("code", null, _toDisplayString(st.code), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(st.name), 1),
                            _createElementVNode("td", null, _toDisplayString(st.comment_required ? "Obligatoire" : "Optionnel"), 1),
                            _createElementVNode("td", null, _toDisplayString(st.reported_date_required ? "Obligatoire" : "—"), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_33, [
                  _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "doc-h2" }, "5. Requête et réponse", -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "doc-h3" }, "Requête", -1)),
                  _createVNode(_component_CodeBlock, {
                    code: _ctx.spec.request_example
                  }, null, 8, ["code"]),
                  _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "doc-h3" }, "Réponse — succès (HTTP 200)", -1)),
                  _createVNode(_component_CodeBlock, {
                    code: _ctx.spec.success_example
                  }, null, 8, ["code"]),
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.spec.success_notes), 1),
                  _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "doc-h3" }, "Réponse — erreur", -1)),
                  _createVNode(_component_CodeBlock, {
                    code: _ctx.spec.error_example
                  }, null, 8, ["code"])
                ]),
                _createElementVNode("section", _hoisted_35, [
                  _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "doc-h2" }, "6. Codes d'erreur", -1)),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("table", _hoisted_37, [
                      _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { scope: "col" }, "HTTP"),
                          _createElementVNode("th", { scope: "col" }, "EDIT-STATUT.MESSAGE"),
                          _createElementVNode("th", { scope: "col" }, "Signification")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spec.errors, (e) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: e.http + e.code
                          }, [
                            _createElementVNode("td", null, _toDisplayString(e.http), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("code", null, _toDisplayString(e.code), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(e.label), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.spec.error_notes), 1)
                ]),
                _createElementVNode("section", _hoisted_39, [
                  _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "doc-h2" }, "7. Exemples", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spec.examples, (ex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: ex.title
                    }, [
                      _createElementVNode("h4", _hoisted_40, _toDisplayString(ex.title), 1),
                      _createVNode(_component_CodeBlock, {
                        code: ex.code
                      }, null, 8, ["code"])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("section", _hoisted_41, [
                  _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "doc-h2" }, "8. Traçabilité", -1)),
                  _createElementVNode("ul", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spec.trace, (t, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(t), 1))
                    }), 128))
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
    ])
  ]))
}